var SessionStorage = {
    get: function (key) {
        if (typeof sessionStorage[key] !== 'undefined') {
            return JSON.parse(sessionStorage[key]);
        }
        return null;
    },
    set: function (key, value) {
        sessionStorage[key] = JSON.stringify(value);
        return value;
    },
    remove: function (key) {
        delete sessionStorage[key];
    }
};
export default SessionStorage;
